import { makeVar, ReactiveVar } from '@apollo/client'

// when there is no session or no lumosityUser Cookie, the user is undefined, this is also getting set from usePersistedClientValues.tsx
// thus there should not be any initial value, because setting it means the user exists, which is not the case

export const currentUserVar: ReactiveVar<LumosUser | undefined> = makeVar<LumosUser | undefined>(undefined)
